import { IUserRepository } from '../repositories/IUserRepository'

export interface IValidateEmail {
  execute(email: string): Promise<void>
}

export default class ValidateEmailImpl implements IValidateEmail {
  constructor(private readonly userRepository: IUserRepository) {}

  public async execute(email: string): Promise<void> {
    await this.userRepository.validateEmail(email)
  }
}
